@if (!useMobileView) {
  <table mat-table [dataSource]="dataSource">
    @for (col of columns; track col.id) {
      <ng-container [matColumnDef]="col.id">
        <th
          *matHeaderCellDef
          mat-header-cell
          [style.width]="col.width"
          [style.min-width]="col.minWidth">
          @if (col.header) {
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                'margin-bottom': 0,
                'max-width': col.header,
              }"></ngx-skeleton-loader>
          }
        </th>

        <td
          *matCellDef
          mat-cell
          [style.width]="col.width"
          [style.min-width]="col.minWidth">
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              'margin-bottom': 0,
              'max-width': col.cell,
            }"></ngx-skeleton-loader>
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
}
@if (useMobileView) {
  <div class="mobile-container-cards">
    <div class="card w-full">
      <ngx-skeleton-loader
        [count]="dataSource.data.length"
        [theme]="{
          'margin-bottom': 0,
          height: '56px',
        }"></ngx-skeleton-loader>
    </div>
  </div>
}
